import hrbLogo from "../../assets/images/hrb-logo.svg";
// @ts-ignore  
import auth from "../user/services/Auth";
import "./Header.scss";
import Translate from "../../lang/Translate";

import LanguageToggle from "../../lang/LanguageToggle";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { Link } from "react-router-dom";
import SelectField from "components/library/input-fields/SelectField";
import { roleOrder } from "utils/constants";
import React, { useCallback, useEffect } from "react";
import { setUserSelectedRole } from "../../store/reducers/user"




const Header = () => {
    const dispatch = useDispatch();
    const userData = useSelector((state: RootState) => state.user.userProfile);
    const userRole = useSelector((state: RootState) => state.user.userSelectedRole);
    const [selectedView, setSelectedView] = React.useState<string>(userRole || "");

    useEffect(() => {
        setSelectedView(userRole || "");
    },[userRole]);

    const handleValueChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>): void => {
        setSelectedView(e.target.value);
        dispatch(setUserSelectedRole(e.target.value));
    }, [dispatch]);


    /**
     * Generates dropdown options based on the user's roles.
     *
     * - Filters out the "ROLE_ONLINE" role from the list of user roles.
     * - Sorts the remaining roles based on a predefined order (`roleOrder`).
     * - Maps each role to an object containing a `value` and a `label`.
     *   - The `value` is the role itself.
     *   - The `label` is a formatted string derived from the role, where the last part
     *     of the role (after the underscore) is capitalized and prefixed with `Options.UserRoles.`.
     *
     * @returns An array of dropdown option objects, each containing:
     * - `value`: The role string.
     * - `label`: A formatted string for display purposes.
     */
    const generateDropDownOptions = () => {
        const userRoles = userData?.userRole || [];
        const userRolesFiltered = userRoles.filter(item=> { return item !== "ROLE_ONLINE"}); // Remoobve ROLE_ONLINE from the list of roles
        const sortedRoles = userRolesFiltered.sort((a, b) => roleOrder.indexOf(a) - roleOrder.indexOf(b));
        return sortedRoles.map(role => ( {
            value: role,
            label: `Options.UserRoles.${role.split("_").slice(-1)[0].charAt(0).toUpperCase()}${role.split("_").slice(-1)[0].slice(1).toLowerCase()}`
        }));
    }

    return (<nav className="navbar header-nav" role="navigation" aria-label="main navigation">
        <div className="navbar-brand">
            <Link to={""} className="navbar-item" style={{ textDecorationLine: "none" }}>
                <img src={hrbLogo} className="pr-1" alt="hrb-logo" />
                <span className="app_name">| <Translate text="app_name" /></span>
            </Link>
        </div>

        <div className="navbar-menu">
            <div className="navbar-end">
                {userData && userRole && <div className="user-role-select-container">
                    <SelectField fieldId="UserRoles" options={generateDropDownOptions()} selectedValue = {selectedView} onChange={handleValueChange}/> 
                </div>}  
                <div className="navbar-item has-dropdown is-hoverable">
                    {Object.keys(userData).length > 0 && (<>
                        <span className="navbar-link"><Translate text="Labels.account" /></span>
                        <div className="navbar-dropdown">
                            <span className="navbar-item pointer" onClick={() => auth.logout()}><Translate text="Labels.sign_out" /></span>
                        </div></>)}
                </div>
                <div className="navbar-item">
                    <div className="buttons">
                        <LanguageToggle />
                    </div>
                </div>
            </div>
        </div>
    </nav>)
};


export default Header;
